// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"71e381a20a793de90696","655":"4622e393b8f8859f88c4"}[chunkId] + ".js";
};